import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import { degreeToCompass } from "utils/helpers/geo_helpers";

// Create styles
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#ffffff",
    width: "100%",
    height: "100%",
    minHeight: 400,
  },
  row: {
    flexDirection: "row",
    width: "100%",
    fontSize: 12,
  },
  rowGray: {
    flexDirection: "row",
    width: "100%",
    fontSize: 12,
    backgroundColor: "#fafafa",
  },
  rowHeader: {
    flexDirection: "row",
    width: "100%",
    marginTop: 10,
    marginBottom: 10,
    fontSize: 14,
    fontWeight: "bold",
    padding: 10,
  },
  col: {
    flexDirection: "column",
    width: "50%",
    padding: 10,
    fontWeight: "normal",
  },
});

// Create Document Component
const PdfStatisticsForestView = (props) => {
  const raccIta = [
    "italy_aspect_slope:rACC_ITA_30m_val1",
    "italy_aspect_slope:rACC_ITA_30m_val2",
    "italy_aspect_slope:rACC_ITA_30m_val3",
  ];

  let totalRaccIta = 0,
    raccItaVal1,
    raccItaVal2,
    raccItaVal3,
    percentRaccIta1,
    percentRaccIta2,
    percentRaccIta3;

  props?.statistics?.map((statRaccIta) => {
    let statRaccItaKey = Object.keys(statRaccIta)[0];
    if (statRaccItaKey === "italy_aspect_slope:rACC_ITA_30m_val1") {
      raccItaVal1 = statRaccIta[statRaccItaKey]?.["feature:count"];
    }
    if (statRaccItaKey === "italy_aspect_slope:rACC_ITA_30m_val2") {
      raccItaVal2 = statRaccIta[statRaccItaKey]?.["feature:count"];
    }
    if (statRaccItaKey === "italy_aspect_slope:rACC_ITA_30m_val3") {
      raccItaVal3 = statRaccIta[statRaccItaKey]?.["feature:count"];
    }
  });

  totalRaccIta = raccItaVal1 + raccItaVal2 + raccItaVal3;
  percentRaccIta1 = (raccItaVal1 / totalRaccIta) * 100;
  percentRaccIta2 = (raccItaVal2 / totalRaccIta) * 100;
  percentRaccIta3 = (raccItaVal3 / totalRaccIta) * 100;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View>
          {props?.srcMapImage ? (
            <Image src={props?.srcMapImage} />
          ) : (
            <Text style={{ textAlign: "center" }}>
              Immagine in caricamento...
            </Text>
          )}
        </View>
        <View style={styles.rowHeader}>
          <Text style={{ fontWeight: "bold" }}>
            Statistiche area selezionata (Regione {props?.region}) - Superficie{" "}
            {props?.projectArea} km2
          </Text>
        </View>

        {props?.statistics?.map((statistic) => {
          let statKey = Object.keys(statistic)[0];
          let title, unit;
          if (raccIta.includes(statKey)) {
            return <Text key={statKey}></Text>;
          }
          switch (statKey) {
            case "forestview:provvigione_legnosa":
              title = "Provvigione Legnosa: GSV - Metri cubi per ettaro l'anno";
              unit = (
                <span>
                  m<sup>3</sup>/ha
                </span>
              );
              break;
            case "forestview:italia_forest_mask":
              title = "Copertura boschiva - Metri cubi per ettaro l'anno";
              unit = (
                <span>
                  m<sup>3</sup>/ha
                </span>
              );
              break;
            case "forestview:italia_cai_model":
              title =
                "Incremento: CAI - Incremento volume legnoso metri cubi per ettaro l'anno";
              unit = (
                <span>
                  m<sup>3</sup>/ha
                </span>
              );
              break;
            case "forestview:biomassa_2005":
              title =
                "Biomassa: AGB - Biomassa Tonnellate (o Megagrammi Mg) per ettaro";
              unit = "Mg/ha";
              break;
            case "italy_aspect_slope:italy_aspect_compr":
              title = "Esposizione";
              unit = "";
              break;
            case "italy_aspect_slope:italy_slope_compr":
              title = "Pendenza";
              unit = "%";
              break;
            case "italy_aspect_slope:racc_ita_30m":
              title = "Accessi boschivi";
              unit = "";
              break;
            default:
              title = "";
              break;
          }
          return (
            <View key={statKey}>
              <View style={styles.rowHeader}>
                <Text style={{ fontWeight: "bold" }}>{title}</Text>
              </View>
              {/* <View style={styles.rowGray}>
                        <Text style={styles?.col}><b>Totale</b></Text>
                        <Text style={styles?.col}>{!isNaN(statistic?.[statKey]?.['feature:count']) ? statistic?.[statKey]?.['feature:count']?.toFixed(2) : ''} {unit}</Text>
                    </View> */}
              {statKey !== "forestview:italia_cai_model" &&
                statKey !== "italy_aspect_slope:italy_slope_compr" &&
                statKey !== "italy_aspect_slope:racc_ita_30m" &&
                statKey !== "italy_aspect_slope:italy_aspect_compr" && (
                  <>
                    <View style={styles.row}>
                      <Text style={styles?.col}>
                        <b>Valore massimo</b>
                      </Text>
                      <Text style={styles?.col}>
                        {!isNaN(statistic?.[statKey]?.["feature:max"])
                          ? statistic?.[statKey]?.["feature:max"]?.toFixed(2)
                          : ""}{" "}
                        {unit}
                      </Text>
                    </View>
                    <View style={styles.rowGray}>
                      <Text style={styles?.col}>
                        <b>Valore minimo</b>
                      </Text>
                      <Text style={styles?.col}>
                        {!isNaN(statistic?.[statKey]?.["feature:min"])
                          ? statistic?.[statKey]?.["feature:min"]?.toFixed(2)
                          : ""}{" "}
                        {unit}
                      </Text>
                    </View>
                  </>
                )}

              {statKey === "italy_aspect_slope:racc_ita_30m" ? (
                <View style={styles.row}>
                  <Text style={styles?.col}>
                    <b>Valore percentuale</b>
                  </Text>
                  <Text style={styles?.col}>
                    <Text>
                      Alta {percentRaccIta1?.toFixed(1)}% - Media{" "}
                      {percentRaccIta2?.toFixed(1)}% - Bassa{" "}
                      {percentRaccIta3?.toFixed(1)}%
                    </Text>
                  </Text>
                </View>
              ) : (
                <View style={styles.row}>
                  <Text style={styles?.col}>
                    <b>Valore medio</b>
                  </Text>
                  <Text style={styles?.col}>
                    {!isNaN(statistic?.[statKey]?.["feature:avg"])
                      ? statKey === "italy_aspect_slope:italy_aspect_compr"
                        ? degreeToCompass(
                            statistic?.[statKey]?.["feature:avg"]?.toFixed(2)
                          )
                        : statistic?.[statKey]?.["feature:avg"]?.toFixed(2)
                      : ""}{" "}
                    {unit}
                  </Text>
                </View>
              )}
            </View>
          );
        })}
      </Page>
    </Document>
  );
};

export default PdfStatisticsForestView;
